import styled from 'styled-components';

export const ImageOverlay = styled.article`
  position: relative;
  min-height: 300px;
  background: ${({ $img }) => $img && `url(${$img}) no-repeat center center / cover;;`};
  color: #fff;
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  text-align: center;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1;
  }
  & > * {
    width: 100%;
    color: #fff;
    position: relative;
    z-index: 2;
  }
`;

export const CharterSection = styled.section`
  margin: 32px 0;

  @media (max-width: 757px) {
    margin: 16px 0;
  }
`;

export const H3Text = styled.h3`
  font-weight: var(--fw-bold);
  font-size: var(--fs-800);
  color: var(--color-theme);
`;
